import { NavigationV2 } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledNavigationV2 = styled(NavigationV2)`
  /* TODO: remove after hhg-components nav pointer-events + arrow stroke fixes are published */
  > section
    *:not([data-cart-menu] *):not([data-search-animation-wrapper]
      *):not([data-search-animation-wrapper]) {
    pointer-events: auto;
  }

  .hhgcomp-navigation-itemnav-headeritem svg path {
    stroke: currentColor;
  }

  &.nav-tarot-game {
    #site-header {
      background-color: transparent;

      .hhgcomp-navigation-itemnav-headeritem {
        border-bottom: none;
      }
    }
  }
`
